export const produceNextCacheEntry = ({
  entity,
  currentEntry,
  nextState
}) => {
  var _currentEntry$state;
  // Don't change the data's reference if it hasn't actually changed
  const hasDataChanged = !!(!currentEntry || !currentEntry.state.data || nextState.data &&
  // Cheap ref check
  currentEntry.state.data !== nextState.data &&
  // Semantic or potentially expensive diff
  entity.hasChanged(currentEntry.state.data, nextState.data));
  const nextStateClone = Object.assign({}, nextState);

  // If the data hasn't changed, preserve the existing reference
  if (currentEntry !== null && currentEntry !== void 0 && (_currentEntry$state = currentEntry.state) !== null && _currentEntry$state !== void 0 && _currentEntry$state.data && nextState !== null && nextState !== void 0 && nextState.data && !hasDataChanged) {
    nextStateClone.data = currentEntry.state.data;
  }
  return {
    state: nextStateClone,
    meta: {
      lastUpdatedAt: Date.now()
    }
  };
};